import { css } from '@emotion/react';

import image from 'src/assets/jpg/succes-failure-hero.jpg';
import hosImage from 'src/assets/jpg/hos-party.jpg';
import { theme } from 'src/styles/theme';
import { getTheme } from 'src/utils/getTheme';

const { isHosTheme } = getTheme();

export const styles = {
    container: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    }),

    imageContainer: css({
        marginBottom: '83px',
        height: '190px',
        flexShrink: 0,
        background: isHosTheme
            ? `url(${hosImage}) lightgray no-repeat center/cover`
            : `url(${image}) lightgray no-repeat center/cover`,
        backgroundPosition: '45% 32%',
        backgroundSize: '150%',

        [theme.breakpoints.up('lg')]: {
            backgroundSize: '100%',
        },
    }),

    wrapper: css({
        padding: '0 20px',
        alignSelf: 'center',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '30px',
        [theme.breakpoints.up('lg')]: {
            width: '494px',
            gap: '40px',
        },
    }),

    subtitle: css({
        textAlign: 'left',
    }),

    cta: css({
        display: 'flex',
        height: '45px',
        padding: '16px 16px 12px 16px',
        justifyContent: 'center',
        gap: '30px',
        alignItems: 'stretch',
        borderRadius: '100px',
        paddingBlock: '16px',
        minWidth: '100%',
        alignSelf: 'stretch',
        marginBottom: '83px',
        textTransform: 'uppercase',

        [theme.breakpoints.up('lg')]: {
            width: '186px',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    }),
};
